import { apiFetch } from './apiFetch';

const API_BASE = process.env.REACT_APP_API_URL;

export async function sendContactUs(form) {
  try {
    const response = await apiFetch(`${API_BASE}/contact-us`, {
      method: 'POST',
      body: JSON.stringify(form),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.message || 'Failed to send message');
    return data;
  } catch (err) {
    throw err;
  }
}
